class Helpers  {
    /**
     * Do Ajax
     */
    doAjax(url, type, dataType, data, done, fail, always) {
        $.ajax({
            url: url,
            type: type,
            dataType: dataType,
            data: data
        }).done(done).fail(fail).always(always);
    }

    /**
     * Convert JSON like string to real JSON
     */
    JSONify(string) {
        let self = this;

        let output = {};

        if (string !== '') {
            output = JSON.parse(string);
            output = self.parseFloatObjectValues(output);
        }

        return output;
    }

    /**
     * Hide element on outside click
     */
    hideElementOnOutsideClick(elementToToggle, toggler, toggleClass, fadeSpeed) {
        $(document).on('click', function (e) {
            let target = $(e.target);
            let href   = e.target.href;

            if (target.closest(elementToToggle).length > 0 || target.closest(toggler).length > 0) {
                if (href) {
                    window.location.href = href;
                }

                return false;
            }

            elementToToggle.fadeOut(fadeSpeed).removeClass(toggleClass);
        });
    }

    /**
     * Print form error messages
     */
    printFormErrorMessage(field, error_text) {
        field.closest(".form-group").append("<span class='error'>" + error_text + "</span>");
    }

    /**
     * Show/hide password
     */
    showHidePassword(toggler) {
        let input = toggler.parent().find('input');

        toggler.toggleClass('fa-eye fa-eye-slash');
        input.attr('type') === 'password' ? input.attr('type', 'text') : input.attr('type','password');
    }

    /**
     * Limit input characters
     */
    limitInputCharacters(field) {
        const handle = function (theField) {
            let limitIndicator = theField.siblings('.remaining-characters');
            let maxLength = theField.attr('maxlength');
            let limitText = limitIndicator.data('limit-text');
            let limitTextSingular = limitIndicator.data('limit-text-singular');
            let textLength = theField.val().length;
            let textRemaining = maxLength - textLength;

            limitIndicator.html(textRemaining + ' ' + (textRemaining > 1 ? limitText : limitTextSingular));
        };

        handle(field);

        field.on('keyup keydown', function () {
            let thisField = $(this);
            handle(thisField);
        });
    }

    /**
     * Multiple serializeArray for forms (containing multiple checkboxes for example)
     */
    multipleSerializeArray(form) {
        let formData = {};

        $.each(form.serializeArray(), function (index, fieldData) {
            if (fieldData.name.endsWith('[]')) {
                let name = fieldData.name.substring(0, fieldData.name.length - 2);
                if (!(name in formData)) {
                    formData[name] = [];
                }
                formData[name].push(fieldData.value);
            } else {
                formData[fieldData.name] = fieldData.value;
            }
        });

        return formData;
    }

    /**
     * Scroll to an element
     */
    scrollToElement(reference, element, offsetCorrection) {
        reference = reference === 'default' ? $('html, body') : reference;

        if (element.length > 0) {
            reference.animate({
                scrollTop: (element.offset().top) + offsetCorrection
            }, 400);
        }
    }

    /**
     * Get a single query param from URL
     */
    getURLQueryParam(name) {
        let querySearch = document.location.search.split('+').join(' ');

        let params = {};
        let tokens = "";
        let re = /[?&]?([^=]+)=([^&]*)/g;

        while (tokens = re.exec(querySearch)) {
            params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
        }

        return params[name];
    }

    /**
     * Add single query param to URL
     */
    addURLQueryParam(key, value) {
        let currentURL = window.location.href;
        let re         = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        let separator  = currentURL.indexOf('?') !== -1 ? '&' : '?';
        let newURL     = '';

        if (currentURL.match(re)) {
            newURL = currentURL.replace(re, '$1' + key + '=' + value + '$2');
        } else {
            newURL = currentURL + separator + key + '=' + value;
        }

        window.history.pushState('', '', newURL);
    }

    /**
     * Remove single query param from URL
     */
    removeURLQueryParam(key, sourceURL) {
        let rtn = sourceURL.split("?")[0],
            param,
            params_arr = [],
            queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";

        if (queryString !== "") {
            params_arr = queryString.split("&");

            for (let i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split("=")[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }

            if (params_arr.length > 0) {
                rtn = rtn + "?" + params_arr.join("&");
            }
        }
        
        window.history.pushState('', '', rtn);
    }

    /**
     * Refine URL
     */
    refineURL() {
        window.history.replaceState(null, null, window.location.pathname);
    }

    /**
     * Append query parameter to a URL string
     */
    appendQueryParameter(url, name, value) {
        if (url.length === 0) {
            return;
        }
    
        let rawURL = url;
    
        if (rawURL.charAt(rawURL.length - 1) === "?") {
            rawURL = rawURL.slice(0, rawURL.length - 1);
        }
    
        const parsedURL = new URL(rawURL);
        let parameters = parsedURL.search;
    
        parameters += (parameters.length === 0) ? "?" : "&";
        parameters = `${parameters}${name}=${value}`;
    
        return `${parsedURL.origin}${parsedURL.pathname}${parameters}`;
    }

    /**
     * Convert RGB colors to HEX format
     */
    rgbToHex(rgb) {
        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);

        return '#' +
            ('0' + parseInt(rgb[1],10).toString(16)).slice(-2) +
            ('0' + parseInt(rgb[2],10).toString(16)).slice(-2) +
            ('0' + parseInt(rgb[3],10).toString(16)).slice(-2);
    }

    /**
     * Get random array value except an element
     */
    getRandomArrayValueExcept(array, toExclude) {
        for (let i = 0; i < array.length; i++) { 
            if (array[i] === toExclude) { 
                array.splice(i, 1); 
            }
        }

        return array;
    }

    /**
     * Detect if an object is empty
     */
    isObjectEmpty(object) {
        for (let key in object) {
            if (object.hasOwnProperty(key)) {
                return false;
            }
        }
    }

    /**
     * Parse float all object values
     */
    parseFloatObjectValues(object) {
        let newObject = {};

        for (let key in object) {
            newObject[key] = parseFloat(object[key]);
        }

        return newObject;
    }

    /**
     * JS nl2br
     */
    nl2br(str, is_xhtml) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }

        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';

        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

    /**
     * Validate telephone number
     */
    isPhoneNumber(phoneNumber) {
        return /^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/.test(phoneNumber);
    }

    /**
     * Print form errors
     */
    formErrors(form, errors) {
        for (let name in errors) {
            form.find('.error-' + name)
                .html(errors[name][0])
                .show()
            ;
        }

        if (typeof(errors) === 'string') {
            form.find('.error.global')
                .html(errors)
                .show()
            ;
        }
    }

    /**
     * Clean form messages
     */
    cleanFormMessages(form) {
        form.find('.success, .error')
            .empty()
            .hide()
        ;
    }

    /**
     * Mark page as unsaved
     */
    markPageAsUnsaved() {
        let currentTitle = window.document.title;

        if (!currentTitle.includes('*')) {
            window.document.title = '* ' + currentTitle;
        }

        window.body.addClass('unsaved');
    }

    /**
     * JS in_array like in PHP
     */
    inArray(needle, haystack) {
        let length = haystack.length;

        for(let i = 0; i < length; i++) {
            if(haystack[i] == needle) {
                return true;
            }
        }

        return false;
    }

    /**
     * Data URL to file
     */
     dataURLtoFile(dataurl, filename) {
        let arr = dataurl.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]); 
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
            
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        
        return new File([u8arr], filename, {type:mime});
    }
}

export default Helpers;